import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { ContactHistoryComponent } from './contact-history.component';
import { ContactHistorySectionComponent } from './contact-history-section/contact-history-section.component';
import { ContactHistorySearchListService } from '../core/service/grid-data/grid-data-contact-history.service';

@NgModule({
  imports:
    [
      SharedModule
    ],
  declarations:
    [
      ContactHistoryComponent,
      ContactHistorySectionComponent
    ],
  exports:
    [
      ContactHistoryComponent,
      ContactHistorySectionComponent
    ],
  providers: [
      ContactHistorySearchListService
    ],
  })
export class ContactHistoryModule { }
